import DeleteTeamParticipant from './DeleteTeamParticipant';
export default DeleteTeamParticipant;
